import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/services/auth/auth.service';
import { LottosService } from '../../../../services/lottos/lottos.service';
import { StoragePermissionService } from '../../../../services/storagePermission/storage-permission.service';
import { ActivatedRoute } from '@angular/router';
import { WindorefService } from '../../../../services/window/windoref.service';

@Component({
  selector: 'app-how-to-play',
  templateUrl: './how-to-play.component' + AuthService.multisite.view + '.html',
  styleUrls: ['./how-to-play.component.scss']
})
export class HowToPlayComponent implements OnInit {
  @Input() system: string;
  public lottoId: number;
  public lottoName: string;
  public lotName: string;
  public country: number;
  public subs: Subscription;
  public countryCode: string;
  public showVideo: boolean = false;
  constructor(
    protected lotto: LottosService,
    protected _storageService: StoragePermissionService,
    private route: ActivatedRoute,
    private _winRef: WindorefService
  ) {}

  ngOnInit(): void {
    this.setLottoId();
    this.countryCode = this._storageService.getCountryCode();
    this.route.queryParams.subscribe((params) => {
      this.showVideo = params.v === 't' ? true : false;
    });
  }

  setLottoId(): void {
    this.subs = this.lotto.lottoObservable$.subscribe((lottoObj) => {
      this.lottoId = lottoObj['id'];
      this.lottoName = this.lottoId === 11 ? 'Mega Da Virada' : lottoObj['name'];
      this.country = lottoObj['country'];
      this.lotName = lottoObj['name']?.replace(/\s+/g, '').toLowerCase();
    });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
